import { render } from "./CreateConfiguration.vue?vue&type=template&id=4fd65c0e&scoped=true"
import script from "./CreateConfiguration.vue?vue&type=script&lang=js"
export * from "./CreateConfiguration.vue?vue&type=script&lang=js"

import "./CreateConfiguration.vue?vue&type=style&index=0&id=4fd65c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd65c0e"]])

export default __exports__